module.exports = __webpack_public_path__ + "static/img/17.20906d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/17.png
// module id = FsQb
// module chunks = 0